import { useTranslation } from 'react-i18next';
import {
    IconAreaTable,
    IconClockTable,
    MarkerTitle,
    Traffic
} from '../../../../../components/buttons/IconButtons';
import CustomCard from '../../../../../components/CustomCard';
import CustomChip from '../../../../../components/CustomChip';
import CustomDaySelector from '../../../../../components/CustomDaySelector';
import CustomModal from '../../../../../components/Modal/CustomModal';
import {status} from '../../../../../enums/statusEnum';
import GeofencesMap from '../../Manage/SubComponents/GeofencesMap';
import SpeedIndicator from '../SubComponents/SpeedIndicator';
import React, {useEffect, useState} from "react";
import {GetGeofenceById} from "../../../../../reduxToolkit/FineGeofence/FineGeofenceApi";
import {useDispatch} from "react-redux";
import {EMPTY_VALUES, errorMsg} from "../../../../../Apis/functions";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import GeofenceUserScope from "../../Manage/SubComponents/GeofenceUserScope";
import {GEOFENCES_MODEL} from "../../Manage/Model/Model";
import {GetAddressFromLatLng} from "../../../../../reduxToolkit/Address/AddressApi";
import CustomTooltip from "../../../../../components/CustomTooltip";

/**
 * @Email  kpozos@ibl.mx
 * @Author Karen Yunuen Pozos Arias
 * @jobTittle FullStack
 */

const DetailsGeofencesModal = (props) => {
    const { item } = props;
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const [geofence, setGeofence] = useState(null);
    const [dayArray, setDayArray] = useState([]);
    const [direction, setDirection] = useState('');
    const [center, setCenter] = useState(null);

    const getLocationData = (lat, lng) => {
        dispatch(GetAddressFromLatLng({ lat, lng, location: 7 })).then(({ payload }) => {
            if (payload?.success) {
                setDirection(payload?.location);
            }
        });
    };

    useEffect(() => {
        if(item)
            dispatch(GetGeofenceById(item)).then(({ payload: { data: { data, success, code } } }) => {
                    if (success) {
                        let g = GEOFENCES_MODEL.toSetMap(data, setDayArray);
                        let center = GEOFENCES_MODEL.getGeofenceCenter(g);
                        setGeofence(g);

                        if(center) {
                            setCenter(center);
                            getLocationData(center[0], center[1]);
                        }
                    } else errorMsg(code);
                })
    }, [item])

    return (
        <CustomModal
            {...props}
            size='lg'
            buttonConfirm='confirm'
            confirmButton={false}
            cancelButton={false}
            display={'m-0px'}
            classNameBody="m-0 p-0"
            topLeftHeader={<>
                <div className='d-flex align-items-center mb-3'>
                    <div>
                        <IconAreaTable width={32} height={32}/>
                    </div>
                    <div className={"flex-grow-1 minw-0"}>
                        <CustomTooltip
                            text={geofence?.name}
                            classes={"font-color-general-950 ibl-font-w-600 fs-24px text-ellipsis-1-row ml-2"}
                            showIfTruncated={true}
                            placement={"top"}
                        />
                    </div>

                    <div className='vertical-separator-shades-950 h-36px' />
                    <CustomChip
                        background={statusColor[geofence?.statusId]}
                        fontColor={statusFontColor[geofence?.statusId]}
                        borderColor={statusBorderColor[geofence?.statusId]}
                        legend={t(status[geofence?.statusId]) || EMPTY_VALUES.DEFAULT}
                        variant={"large"}
                    />
                </div>
            </>
            }
        >
            <Traffic className={'w-100'} />

            <CustomCard classCard={'card-border-8px'} classes={'p-0'}>
               <div className={"row"}>
                   <div className='col-sm-12 col-md-6 border-full-shades-300 pb-3 border-radius-8px p-0' >
                       <div className='d-flex align-items-center gap-2 p-3'>
                           <MarkerTitle width={18} height={18}/>
                           <p className='fs-16px ibl-font-w-600'>{t('location')}</p>
                       </div>
                       {center && geofence &&
                           <div className={"mb-3 h-300px"}>
                               <GeofencesMap
                                   center={center}
                                   geofences={geofence ? [geofence] : []}
                                   showTitle={false}
                                   classNameMap="h-100"
                               />
                           </div>
                       }
                       <div className="col-12">
                           <p className="fs-12px ibl-font-w-500 font-color-primary-700">{direction}</p>
                       </div>
                   </div>
                   <div className='col-sm-12 col-md-6'>
                       <div className={"row"}>
                           <p className='pt-4 fs-14px ibl-font-w-600'>{t('active_schedule')}</p>
                           <div className={"border-bottom-shades-300 mt-1 mb-3"}/>
                           <CustomDaySelector
                               dayArray={dayArray}
                               setDayArray={() => {}}
                               containerClasses={"no-width"}
                               readonly={true}
                           />
                       </div>

                       <div className={"row my-3"}>
                           <div className='d-flex align-items-center'>
                               <IconClockTable className={"mr-8px mb-1"}/>
                               {geofence?.opening} {t("to").toLowerCase()} {geofence?.closing}
                           </div>
                       </div>

                       <div className={"row"}>
                           <div className='d-flex gap-3'>
                               <div className={"flex-grow-1 minw-0"}>
                                   <p className='fs-14px ibl-font-w-600'>{t('speed_limit')}</p>
                                   <div className={"border-bottom-shades-300 mt-1 mb-3"}/>
                                   <SpeedIndicator
                                       speed={geofence?.speedLimit}
                                       speedUnit={geofence?.speedUnit}
                                   />
                               </div>
                               <div className={"flex-grow-1 minw-0"}>
                                   <p className='fs-14px ibl-font-w-600'>{t('speed_tolerance')}</p>
                                   <div className={"border-bottom-shades-300 mt-1 mb-3"}/>
                                   <SpeedIndicator
                                       speed={"+ " + geofence?.speedTolerance}
                                       speedUnit={geofence?.speedUnit}
                                   />
                               </div>
                           </div>
                       </div>

                       <div className='row pt-4'>
                           <p className='fs-14px ibl-font-w-600'>{t('user_scope')}</p>
                           <div className={"border-bottom-shades-300 mt-1 mb-3"}/>
                           <GeofenceUserScope geofence={geofence}/>
                       </div>
                   </div>
               </div>
            </CustomCard>
        </CustomModal>
    );
};

export default DetailsGeofencesModal;


